import { Toast } from "antd-mobile";
import { message, Select, Upload } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { imageConfig } from "../../../../config/config";
import { useTranslation } from "react-i18next";
import { getText } from "../../../../utils/util";

export default function Info({ userInfo, sendAuth }) {
  const navigate = useNavigate();
  const [realName, setRealName] = useState("");
  const [cardzm, setCardzm] = useState("");
  const [cardfm, setCardfm] = useState("");
  const [rztype, setRztype] = useState(1);
  const [phone, setPhone] = useState("");
  const { t: translate } = useTranslation();
  const [fileNowName, setfileNowName] = useState("");

  // Click preview
  const preview = (name) => {
    setfileNowName(name);
  };
  
  // Upload handling
  const handleChange = (info) => {
    if (info.file.status === "done") {
      if (info.file.response && info.file.response.ok) {
        Toast.show({
          content: `${info.file.name} ${translate(getText("上傳成功"))}`,
        });
        const data = info.file.response;
        if (fileNowName === "cardzm") {
          setCardzm(data.data);
        }
        if (fileNowName === "cardfm") {
          setCardfm(data.data);
        }
      } else {
        Toast.show({ content: translate(getText(`上传失败`)) });
      }
    } else if (info.file.status === "error") {
      Toast.show({ content: translate(getText(`上传失败`)) });
    }
  };
  
  // Reset form data
  const reloadData = () => {
    setRealName("");
    setCardzm("");
    setCardfm("");
    setRztype(1);
    setPhone("");
  };
  
  // Load user info on change
  useEffect(() => {
    setRealName(userInfo?.realName);
    setCardzm(userInfo?.cardzm);
    setCardfm(userInfo?.cardfm);
    setRztype(userInfo?.rztype ? parseInt(userInfo?.rztype) : 1);
    setPhone(userInfo?.phone);
  }, [userInfo]);

  return (
    <div className="w-full py-4 px-4 sm:px-6">
      <div className="w-full">
        {/* Form Card */}
        <div className="bg-neutral-800 rounded-xl shadow-card mb-6 overflow-hidden">
          <div className="p-5 sm:p-6">
            <div className="space-y-5">
              {/* Document Type */}
              <div className="mb-6">
                <label className="text-neutral-200 font-medium mb-2 block text-sm">
                  {translate(getText("證件類型："))}
                </label>
                <Select
                  defaultValue={rztype}
                  value={rztype}
                  className="custom-select w-full h-11 rounded-2xl bg-neutral-700 text-white border-neutral-600" 
                  options={[
                    { value: 1, label: translate(getText(`护照`)) },
                    { value: 2, label: translate(getText(`驾驶证`)) },
                    { value: 3, label: "SSN" },
                    { value: 4, label: translate(getText(`身份ID`)) },
                  ]}
                  onChange={(val) => {
                    setRztype(val);
                  }}
                  dropdownStyle={{ zIndex: 9999 }}

                />
              </div>

              {/* Name */}
              <div className="mb-6">
                <label className="text-neutral-200 font-medium mb-2 block text-sm">
                  {translate(getText("姓名"))}
                </label>
                <input
                  className="w-full h-11 px-4 bg-neutral-700 border border-neutral-600 rounded focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-white"
                  type="text"
                  placeholder={translate(getText("請輸入您的真實姓名"))}
                  value={realName}
                  onChange={(e) => {
                    setRealName(e.target.value);
                  }}
                />
              </div>

              {/* Phone */}
              <div className="mb-6">
                <label className="text-neutral-200 font-medium mb-2 block text-sm">
                  {translate(getText("聯繫電話"))}
                </label>
                <input
                  className="w-full h-11 px-4 bg-neutral-700 border border-neutral-600 rounded focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent text-white"
                  type="text"
                  placeholder={translate(getText("請填寫聯繫電話"))}
                  value={phone}
                  onChange={(e) => {
                    setPhone(e.target.value);
                  }}
                />
              </div>

              {/* Document Photos Section */}
              <div className="mt-8">
                <h3 className="text-neutral-200 font-medium mb-4 text-sm">
                  {translate(getText("證件照"))}
                </h3>
                
                {/* Document Photos Container - Show side by side on larger screens */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {/* Front ID Card Photo */}
                  <div className="upload-container">
                    <Upload
                      name="file"
                      accept="image/*"
                      showUploadList={false}
                      action={imageConfig.uploadUrl}
                      onChange={handleChange}
                    >
                      <div 
                        onClick={() => preview("cardzm")}
                        className={`flex flex-col items-center justify-center border-2 border-dashed ${cardzm ? 'border-primary/30' : 'border-neutral-600'} rounded-lg cursor-pointer hover:border-primary transition-colors duration-200 overflow-hidden h-48 sm:h-56`}
                      >
                        {cardzm ? (
                          <div className="w-full h-full relative">
                            <img
                              src={imageConfig.baseImageUrl + cardzm}
                              className="w-full h-full object-cover"
                              alt={translate(getText("證件正面照片"))}
                            />
                          </div>
                        ) : (
                          <div className="py-8 px-4 w-full h-full flex items-center justify-center">
                            <div className="flex flex-col items-center justify-center">
                              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                                </svg>
                              </div>
                              <p className="text-neutral-400 text-center">
                                {translate(getText("證件正面照片"))}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </Upload>
                  </div>

                  {/* Back ID Card Photo */}
                  <div className="upload-container">
                    <Upload
                      name="file"
                      accept="image/*"
                      showUploadList={false}
                      action={imageConfig.uploadUrl}
                      onChange={handleChange}
                    >
                      <div 
                        onClick={() => preview("cardfm")}
                        className={`flex flex-col items-center justify-center border-2 border-dashed ${cardfm ? 'border-primary/30' : 'border-neutral-600'} rounded-lg cursor-pointer hover:border-primary transition-colors duration-200 overflow-hidden h-48 sm:h-56`}
                      >
                        {cardfm ? (
                          <div className="w-full h-full relative">
                            <img
                              src={imageConfig.baseImageUrl + cardfm}
                              className="w-full h-full object-cover"
                              alt={translate(getText("證件反面照片"))}
                            />
                          </div>
                        ) : (
                          <div className="py-8 px-4 w-full h-full flex items-center justify-center">
                            <div className="flex flex-col items-center justify-center">
                              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-primary" viewBox="0 0 20 20" fill="currentColor">
                                  <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                                </svg>
                              </div>
                              <p className="text-neutral-400 text-center">
                                {translate(getText("證件反面照片"))}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </Upload>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <button
                className={`w-full py-3 px-4 rounded-lg font-medium text-white ${userInfo?.rzstatus === 2 ? 'bg-neutral-400 cursor-not-allowed' : 'bg-gradient-primary hover:opacity-90'} transition-all duration-200 shadow-md mt-6`}
                onClick={() => {
                  if (userInfo?.rzstatus === 2) {
                    return;
                  }
                  sendAuth({
                    ...userInfo,
                    realName,
                    cardzm,
                    cardfm,
                    rztype,
                    phone,
                  });
                  reloadData();
                }}
                disabled={userInfo?.rzstatus === 2}
              >
                {translate(getText("提交"))}
              </button>
            </div>
          </div>
        </div>

        {/* Info Card */}
        <div className="bg-neutral-800 rounded-xl shadow-card p-5 sm:p-6 mb-6">
          <div className="text-neutral-300">
            <h4 className="font-medium text-base mb-4 text-neutral-200">
              {translate(getText("提交身份證正反面、手持人臉識別必要清晰、照片符合標準JPG格式。系統採用曠視，證合一，避免了用戶身份信息被盜用等人工幹預的情況，平臺務必保管用戶交易賬戶資金的安全性。溫馨提示："))}
            </h4>
            <ul className="space-y-2 text-sm list-disc pl-5">
              <li>{translate(getText("在驗證期間請確保網絡通暢"))}</li>
              <li>{translate(getText("確保不會被安全軟件攔截"))}</li>
              <li>{translate(getText("同步手機時間，確保時間與當地時區一致"))}</li>
              <li>{translate(getText("請勿佩戴眼鏡、帽子"))}</li>
              <li>{translate(getText("請在光線充足的環境進行驗證"))}</li>
              <li>{translate(getText("使用手機驗證請關閉手機的美顏、修圖等功能"))}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
